<template>
  <div>
    <el-popover trigger="manual" placement="bottom" v-model="visible">
      <!-- <el-input v-model="text" slot="reference" :placeholder="$t('inSrock.searchingFor')" style="width: 380px;" clearable @clear="clear" @keyup.enter.native="search(text)">
        <el-button slot="append" icon="el-icon-search" @click="search(text)"></el-button>
      </el-input> -->
      <div class="search" slot="reference">
        <div id ="search" class="input f-b-c" target="search_onclick" @click="openPopver">
          <el-input v-model="text" :placeholder="$t('headerBar.searchingFor')" @keyup.enter.native="search(text)" @input="inputSearch"></el-input>
        </div>
        <div class="camera f--c">
          <i v-if="isPC" class="iconfont icon-photo pointer" style="font-size:24px;color:#747A87;display: block;margin-top:1px" :title="$t('commodity.Components.Search.UploadAPicture')" @click="$emit('showUploadPopout', true)" />
          <photograph v-else>
            <i class="iconfont icon-photo" style="font-size:24px;color:#747A87;display: block;margin-top:1px" :title="$t('commodity.Components.Search.UploadAPicture')" />
          </photograph>
        </div>
        <div class="icon f-c-c pointer" @click="search(text)">
          <i class="iconfont icon-a-search-line1"></i>
        </div>
      </div>
      <div v-if="showRecommend" class="search-box">
        <p style="font-weight: 400;font-size: 14px;line-height: 24px;color: #000000;padding-bottom:15px" v-for="(item,index) in recommendList" :key="index" class="pointer" @click="search(item)">{{item}}</p>
      </div>
      <div class="search-box" v-if="showHotSearCh">
        <h3 v-if="recentSearches && recentSearches.length" class="f-b-c">
          {{$t('inSrock.recentSearches')}}
        </h3>
        <span class="cue-word pointer ellipsis" style="display:inline-block;" v-for="item in recentSearches" :key="`recent_${item}`" @click="search(item)">{{item}}</span>
        <h3>
          <i class="iconfont icon-huo" style="color: #A6100C;"></i>
          {{$t('inSrock.hotSearches')}}
        </h3>
        <span class="cue-word pointer ellipsis" v-for="(item,i) in hotSearches" :key="`hot_${item}_${i}`" @click="search(item)">{{item}}</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
import API from '@/api'
import { languageMap } from '@/config/languageMap'
import bus from '@/util/bus'
import Photograph from '../../index/components/Photograph.vue'
export default {
  components: { Photograph },
  data() {
    return {
      visible: false,
      showRecommend: false,
      showHotSearCh: false,
      recommendList: [],
      text: '',
      recentSearches: [], // 最近搜索词列表
      hotSearches: [] // 热搜词列表
    }
  },
  created() {
    this.getSearches()
  },

  watch: {
    '$route.query'(value) {
      if (value.categoryId) {
        this.text = ''
      }
    }
  },

  mounted() {
    const search = document.querySelector('#search')
    const clickSearch = (e) => {
      if (this.visible && !search.contains(e.target)) {
        this.visible = false
      }
    }
    document.addEventListener('click', clickSearch)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('click', clickSearch)
    })
    // 判断地址栏是产品列表，并且有搜索内容，回显搜索内容
    if (this.$route.path.includes('/product-list') && this.$route.query && this.$route.query.search) {
      this.text = this.$route.query.search
    }
  },
  methods: {
    openPopver() {
      if (this.checkText(this.text)) {
        let form = { text: this.text, language: languageMap[this.$store.state.language] || 1 }
        this.suggestionCompletion(form)
      } else if (this.text === '') {
        this.visible = true
        this.showHotSearCh = true
      }
      this.$record({
        eventType: 'click',
        eventId: `headerSearchInput_click`,
        value: ''
      })
    },
    setSearches(text) {
      this.text = text
    },
    inputSearch(value) {
      let form = { text: value, language: languageMap[this.$store.state.language] || 1 }
      this.suggestionCompletion(form)
    },
    checkText(value) {
      let regEx = /[\`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、' ']/im
      let arr = value.trim().split('').filter(item => item !== '')
      let res = arr.some(item => { return !regEx.test(item) })
      return res
    },
    suggestionCompletion(form) {
      API.suggestionCompletion(form).then(res => {
        this.recommendList = res.data
        if (this.recommendList.length > 0) {
          this.showRecommend = true
          this.showHotSearCh = false
          this.visible = true
        } else {
          this.showRecommend = false
          this.visible = false
        }
      })
    },
    getSearches() {
      API.getSearches({ userId: this.$store.state.common.userId }).then(result => {
        this.recentSearches = result.data.userHotTermsList
        this.hotSearches = result.data.globalHotTermsList
      })
    },
    search(text) {
      if (!text) { // 当Heafer的搜索为空时默认跳转到最大的商品列表页面
        location.href = '/product-list'
        return
      }
      this.text = text
      this.$emit('search', text)
      // this.$nextTick(() => {
      //   bus.$emit('searches', text)
      // })
      if (text) {
        this.$record({
          eventType: 'search',
          eventId: `headerSearchInput_search`,
          value: JSON.stringify({
            search: text
          })
        })
      }
      this.showRecommend = false
      this.visible = false
    },
    clear() {
      this.$emit('search', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  max-width: 720px;
  min-width: 510px;
  width: 50vw;
  height: 44px;
  margin-left: 3vw;
  margin-right: .5vw;
  border-radius: 44px;
  background: #F5F7F7;
  position: relative;

  .input {
    position: absolute;
    width: 90%;

    img {
      width: 26px;
      height: 22px;
    }

    /deep/ .el-input--medium .el-input__inner {
      height: 44px;
      width: 100%;
      border: unset;
      background-color: unset;
    }
  }

  .camera {
    position: absolute;
    right: 10%;
    top: 0;
    bottom: 0;
    margin: auto;

    /deep/.upload-img{
      display: flex;
    }
  }

  .icon {
    position: absolute;
    right: 0;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: #99C41C;

    i {
      color: #fff;
      font-size: 19px;
    }
  }
}

.search-box{
  // width: 450px;
  // min-height: 480px;
  max-width: 680px;
  min-width: 470px;
  width: 46vw;
  padding: 15px;
  h3{
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    padding-bottom: 15px;
    .clear{
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #747A87;
    }
  }
  .cue-word{
    display: inline-block;
    white-space: nowrap;
    max-width: 200px;
    padding: 5.5px 12px;
    margin: 0 10px 17px 0;
    background: #F5F7F7;
    border-radius: 100px;
    overflow: hidden;
  }
}
</style>
